const tileImages: { [Key: string]: { [key: number]: string } } = {
  easy: {
    1: "javaScript",
    2: "typeScript",
    3: "react",
    4: "next",
    5: "jest",
    6: "frontEnd",
    7: "backEnd",
    8: "fullStack",
  },
  normal: {
    1: "avatar1",
    2: "avatar2",
    3: "avatar3",
    4: "avatar4",
    5: "avatar5",
    6: "avatar6",
    7: "avatar7",
    8: "avatar8",
  },
  hard: {
    1: "avatar_mono1",
    2: "avatar_mono2",
    3: "avatar_mono3",
    4: "avatar_mono4",
    5: "avatar_mono5",
    6: "avatar_mono6",
    7: "avatar_mono7",
    8: "avatar_mono8",
  },
};

export default tileImages;
